export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7902.8c63b7aa.jpg";